import { useQuery } from 'react-query';

import { ApiVerb, apiPost } from 'src/utils/api';

import {
  EMPLOYEE_QUERY_KEY,
  GoogleEmployeeIntegration,
  GreenhouseOAuthEmployeeIntegration,
  MicrosoftEmployeeIntegration,
  SlackEmployeeIntegration,
} from './types';

interface ListEmployeeIntegrationResponse {
  employee_id?: string;
  org_id?: string;
  slack?: SlackEmployeeIntegration;
  google?: GoogleEmployeeIntegration;
  microsoft?: MicrosoftEmployeeIntegration;
  microsoft_gcc_high_employee?: MicrosoftEmployeeIntegration;
  microsoft_custom_employee?: MicrosoftEmployeeIntegration;
  microsoft_service_user?: MicrosoftEmployeeIntegration;
  greenhouse_oauth_employee?: GreenhouseOAuthEmployeeIntegration;
}

async function listUserIntegration(): Promise<ListEmployeeIntegrationResponse> {
  const response = await apiPost(ApiVerb.LIST_EMPLOYEE_INTEGRATION, {});
  return response.data;
}

export default function useEmployeeIntegrations() {
  return useQuery(EMPLOYEE_QUERY_KEY, () => listUserIntegration());
}
